import { useQuery } from '@tanstack/react-query';
import { getBackups } from '../api/backups';

export function useBackups(subscriptionId: string) {
  return useQuery({
    queryKey: ['backups', subscriptionId],
    queryFn: () => getBackups(subscriptionId),
    enabled: !!subscriptionId,
    staleTime: 60 * 1000, // 1 minute
  });
}
